'use strict';

var React = require('react');

var SvgBankMajor = function SvgBankMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 6h20c0-.604-.368-1.147-.928-1.371l-8.515-3.406a1.5 1.5 0 0 0-1.114 0l-8.515 3.406c-.56.224-.928.767-.928 1.371zm0 2v1a1 1 0 0 0 1 1v7a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2v-7a1 1 0 0 0 1-1v-1h-20zm4 2h2v7h-2v-7zm7 0h-2v7h2v-7zm3 0h2v7h-2v-7z"
  }));
};

exports.SvgBankMajor = SvgBankMajor;
